import { render, staticRenderFns } from "./err-list.vue?vue&type=template&id=7990136e&scoped=true&"
import script from "./err-list.vue?vue&type=script&lang=js&"
export * from "./err-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990136e",
  null
  
)

export default component.exports